/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1nmz9jpi%7Bword-break%3Abreak-all%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._o5726vc6%7Bwhite-space%3Apre-line%7D");
import type { ComponentType, FC } from 'react';
import { FormattedMessage, injectIntl, IntlProvider, type WithIntlProps, type WrappedComponentProps } from 'react-intl';
import Button from '@atlaskit/button/standard-button';
import Link from '@atlaskit/link';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { messages } from '../../../messages';
const breakWordsCss = null;
export type LinkWarningModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  unsafeLinkText: string | null;
  url: string | null;
};
const WarningModal = (props: LinkWarningModalProps & WrappedComponentProps) => {
  const {
    isOpen,
    unsafeLinkText,
    url,
    onClose,
    onContinue,
    intl
  } = props;
  const content = <ModalTransition>
			{isOpen && <Modal onClose={onClose} testId="link-with-safety-warning">
					<ModalHeader hasCloseButton>
						<ModalTitle appearance="warning">
							<FormattedMessage {...messages.check_this_link} />
						</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<div className={ax(["_o5726vc6 _1nmz9jpi"])}>
							{url && unsafeLinkText && <FormattedMessage {...messages.link_safety_warning_message} values={{
            unsafeLinkText: unsafeLinkText,
            a: () => <Link href={url} target="_blank" rel="noopener noreferrer">
												{url}
											</Link>
          }} />}
						</div>
					</ModalBody>
					<ModalFooter>
						<Button appearance="subtle" onClick={onClose}>
							<FormattedMessage {...messages.go_back} />
						</Button>
						<Button appearance="warning" onClick={onContinue} autoFocus>
							<FormattedMessage {...messages.continue} />
						</Button>
					</ModalFooter>
				</Modal>}
		</ModalTransition>;
  return intl ? content : <IntlProvider locale="en">{content}</IntlProvider>;
};
const _default_1: FC<WithIntlProps<LinkWarningModalProps & WrappedComponentProps>> & {
  WrappedComponent: ComponentType<LinkWarningModalProps & WrappedComponentProps>;
} = injectIntl(WarningModal, {
  enforceContext: false
});
export default _default_1;